/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_TitleInputs */

const da_forside_example_title = /** @type {(inputs: Forside_Example_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksempelprøve med fiktive elever`)
};

/** @type {(inputs: Forside_Example_TitleInputs) => LocalizedString} */
const en_forside_example_title = da_forside_example_title;

/**

* @param {Forside_Example_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_title = /** @type {((inputs?: Forside_Example_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_title(inputs)
	return /** @type {LocalizedString} */ ("Eksempelprøve med fiktive elever")
});